// extracted by mini-css-extract-plugin
export default {"mainFooter":"Footer-module__mainFooter--NBUen"};